import React from 'react';
import { connect } from 'react-redux';
import ListItem from '@components/common/header/sp-menu/list-item';
import { Cont, Box, LangSelecta } from '@components/common/header/sp-menu/styles';

const SpMenu: React.FC = ({ isMenuOpen }) => {

	return (
		<Cont isMenuOpen={ isMenuOpen } >
			<Box>
				<ul>
					<ListItem name="Strength" to="/strength" />
					<ListItem name="Services" to="/services" >
						<ListItem name="Production Flow" to="/flow" isChild={true} />
						<ListItem name="Our Products" to="/products" isChild={true} />
						<ListItem name="Quality" to="/quality" isChild={true} />
					</ListItem>
					<ListItem name="Facility" to="/facility" />
					<ListItem name="Company Information" to="/company" >
						<ListItem name="Message" to="/message" isChild={true} />
					</ListItem>
					<ListItem name="Contact" to="/contact" />
				</ul>
				<LangSelecta/>
			</Box>
		</Cont>
	);
}

const mapStateToProps = state => ({
	isMenuOpen : state.spMenuReducer.isMenuOpen,
})
export default connect(mapStateToProps)(SpMenu);
